const NAME_UTIL = "KibernetesSpinner";

export default class KibernetesSpinner {
	#spinner;

	constructor() {
	}
	#create() {
		const d = document.createElement("div");
		d.className = 'modal';
		d.style.zIndex = '999999';
		d.tabindex = '-1';
		d.role = 'dialog';
		d.innerHTML = '<div id="kib-spinner" class="modal-dialog modal-dialog-centered" role="document"><div class="modal-content" style="background-color: transparent;"><div class="modal-body mx-auto" style="background-color: transparent;"><div class="progress-spinner progress-spinner-double progress-spinner-active"><div class="progress-spinner-inner"></div><div class="progress-spinner-inner"></div><span class="visually-hidden">Caricamento...</span></div></div></div></div>';
		document.body.appendChild( d );
		this.#spinner = new bootstrap.Modal( d, {
			keyboard: false,
		} );
	}
	show() {
		const div = document.getElementById('kib-spinner');
		if ( !div ) {
			this.#create();
		}
		this.#spinner.show();
	}
	hide() {
		this.#spinner.hide();
	}
}
